import React, { useCallback, useContext, useState } from "react";
import { Grid, Button, Popup, Icon } from 'semantic-ui-react';
import { Header } from "../commonComponents/index";
import { useSelector } from "react-redux";
import { isEmpty } from 'lodash'
import ButtonMapper from "../buttonMapper/index";
import CopyFieldIcon from "../commonComponents/CopyFieldIcon";
import { ReconGlobalContext } from "../providers/ReconGlobalProvider";

const ReconHeader = ({setShowStatusDetail, showStatusDetail}) => {
  const {currentJob} = useSelector((state) => state.currentJob)
  const {kxUser: {channelConnections: {customersConnected:importerList=[]}={}}} = useContext(ReconGlobalContext);
  const statusDetailToggle = (e) => {
    setShowStatusDetail(!showStatusDetail);
  }
  const headerContentRenderForm = (data) => {
    const importerCode = data.importerCode;
    const importer = importerList.filter((item) => item.customerCode === importerCode)[0];
    return(
      <>
        <Grid.Column>
          <b>KX Id:</b> {data.shippingId} {<CopyFieldIcon fieldInfo={data.shippingId} />}
        </Grid.Column>
        <Grid.Column>
          <b>Entry Number:</b> {data.filerCode}{data.entryNumber} {<CopyFieldIcon fieldInfo={data.entryNumber} />}
        </Grid.Column>
        <Grid.Column>
          <b>Port:</b> {data.processingPort}
        </Grid.Column>
        <Grid.Column>
          <b>Importer Name:</b> {importer.companyName}
        </Grid.Column>
        <Grid.Column>
        </Grid.Column>
      </>
    )
  }
  const headerFooterRenderItem = (data) => {
    return(
      <>
        <Grid.Column width={2}>
          {data.reconShipmentStatus?.toLowerCase() === "completed" ? <Icon name="check circle" color="green" /> : <Popup content={data.reconShipmentStatus} position='right center' trigger={<Icon name="info circle" color="black" />} />}<b>Job Status</b> {data.reconShipmentStatus}
        </Grid.Column>
        <Grid.Column width={4}>
        {data.reconCbpStatus?.toLowerCase() === "accepted" ? <Icon name="check circle" color="green" /> : <Popup content={data.reconCbpStatus ? data.reconCbpStatus : "NONE"} position='right center' trigger={<Icon name="info circle" color="black" />} />}<b>CBP Status</b> {data.reconCbpStatus ? data.reconCbpStatus : "NONE"}
        </Grid.Column>
        <Grid.Column textAlign='right' width={4}>
          <Button size="mini" className="status-detail-btn" onClick={statusDetailToggle}>{!showStatusDetail ? "STATUS DETAIL" : "HIDE STATUS DETAIL"}</Button>
        </Grid.Column>
      </>
    )
  }
  return ( 
      <Header buttonMapper={<ButtonMapper />} headerData={currentJob} headerContentRenderItem={headerContentRenderForm} headerFooterRenderItem={headerFooterRenderItem} />
    );
}
 
export default ReconHeader;